import AdminDashboard from './components/AdminDashboard';
import AdminSiteRedirect from './features/platform/AdminSiteRedirect';
import BrandManagement from './features/brand/BrandManagement';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css';
import './App.css';
import './styles/fleet-admin.css';
import { Route, Routes } from 'react-router-dom';
import LineCallback from './pages/LineCallback';
import PageNotFoundPage from './pages/PageNotFound';
import Login from './pages/Login';
import LiffCallback from './pages/LiffCallback';
import AdminPage from './pages/Admin/Index';
import DriverApprovalList from './pages/Admin/DriverApprovalList';
import LeadApplicationList from './pages/Admin/LeadApplicationList';
import DriverProfileEdit from './pages/Admin/DriverProfileEdit';
import OrderDetail from './pages/Admin/OrderDetail';
import VehicleList from './pages/Admin/VehicleList';

import UserList from './pages/Admin/UserList';
import OrderListCalendar from './pages/Admin/OrderListCalendar';
import AdminCreateOrder from './pages/Admin/AdminCreateOrder';
import ProtectedRoute from './components/ProtectedRoute';
import AdminEditOrder from "./pages/Admin/AdminEditOrder";
import AnnouncementPage from "./pages/Admin/Announcement";
import AccountInfoPage from './pages/Admin/AccountInfo';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CommissionPaymentList from './pages/Admin/CommissionPaymentList';
import CommissionPaymentDetail from './pages/Admin/CommissionPaymentDetail';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/platform/login" element={<AdminSiteRedirect path="/platform/login" />} />
        <Route path="/platform/brands" element={<AdminSiteRedirect path="/platform/brands" />} />
        <Route path="/brands" element={<AdminSiteRedirect path="/brand/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/line/:teamCode/callback" element={<LineCallback />} />
        <Route path="/line/:teamCode/liffcallback" element={<LiffCallback />} />

        <Route path="/" element={<ProtectedRoute />}>
          <Route index element={<AdminPage />} />
          <Route path="brand-orders" element={<BrandManagement />} />
          <Route path="drivers/approval" element={<DriverApprovalList />} />
          <Route path="lead-applications" element={<LeadApplicationList />} />
          <Route path="drivers/:userUID/edit" element={<DriverProfileEdit />} />
          <Route path="orders" element={<OrderListCalendar />} />
          <Route path="orders/:orderId" element={<OrderDetail />} />
          <Route path="vehicles" element={<VehicleList />} />
          <Route path="service-fees" element={<AdminDashboard title="費率管理"><div className="fleet-empty">車隊費率已移至品牌管理，請由品牌設定售價。</div></AdminDashboard>} />
          <Route path="users" element={<UserList />} />
          <Route path="orders/create" element={<AdminCreateOrder />} />
          <Route path="orders/edit/:orderId" element={<AdminEditOrder />} />
          <Route path="announcements" element={<AnnouncementPage />} />
          <Route path="account-info" element={<AccountInfoPage />} />
          <Route path="commission-payments" element={<CommissionPaymentList />} />
          <Route path="commission-payments/:orderId" element={<CommissionPaymentDetail />} />
        </Route>

        <Route
          path="*"
          element={<PageNotFoundPage />}
        />
      </Routes>
    </div >
  );
}

export default App;
